import { AssistantSpeakerRole, AssistantVoiceStatus } from '../../../../../../pure-js/types/AppAssistant'

/** What the voice control says, per session state. Lookup rather than a chain of conditionals. */
const VOICE_STATUS_LABEL_KEYS: Record<AssistantVoiceStatus, string> = {
  [AssistantVoiceStatus.IDLE]: 'gamer.ariaCoach.voiceStart',
  [AssistantVoiceStatus.REQUESTING_MIC]: 'gamer.ariaCoach.voiceMic',
  [AssistantVoiceStatus.CONNECTING]: 'gamer.ariaCoach.voiceConnecting',
  [AssistantVoiceStatus.LIVE]: 'gamer.ariaCoach.voiceLive',
  [AssistantVoiceStatus.ERROR]: 'gamer.ariaCoach.voiceError',
  [AssistantVoiceStatus.CLOSED]: 'gamer.ariaCoach.voiceStart'
}

/** While live, the label follows whoever is talking — a single static line reads as "nothing happening". */
const LIVE_SPEAKER_LABEL_KEYS: Record<AssistantSpeakerRole, string> = {
  [AssistantSpeakerRole.USER]: 'gamer.ariaCoach.voiceHearingYou',
  [AssistantSpeakerRole.ASSISTANT]: 'gamer.ariaCoach.voiceAriaSpeaking'
}

export type CoachVoiceStatusInput = {
  status: AssistantVoiceStatus
  hasError: boolean
  /** Who currently holds the turn, from the live transcript. */
  speaker?: AssistantSpeakerRole
  /** She owes a reply and has not begun it. Her first one is generated from the whole context block. */
  isThinking?: boolean
}

/** An error message outranks the status, because it is the thing the user has to act on. */
export function resolveVoiceStatusLabelKey({ status, hasError, speaker, isThinking }: CoachVoiceStatusInput): string {
  if (hasError) return VOICE_STATUS_LABEL_KEYS[AssistantVoiceStatus.ERROR]
  if (status !== AssistantVoiceStatus.LIVE) return VOICE_STATUS_LABEL_KEYS[status]
  // Ahead of the speaker, or the silence before her first word still reads as "listening to you".
  if (isThinking) return 'gamer.ariaCoach.voiceAriaThinking'
  return speaker ? LIVE_SPEAKER_LABEL_KEYS[speaker] : VOICE_STATUS_LABEL_KEYS[status]
}

/** Mic permission and socket setup — the session is starting but not usable yet. */
export function isVoiceConnecting(status: AssistantVoiceStatus): boolean {
  return status === AssistantVoiceStatus.CONNECTING || status === AssistantVoiceStatus.REQUESTING_MIC
}
